import { ValComponent } from '../../interfaces/val-component.interface';
import { Component, ContentChild, ElementRef, EventEmitter, HostBinding, HostListener, Input, ViewChild } from '@angular/core';

import { ValValidationComponent } from '../val-validation/val-validation.component';
import { ValValidator } from '../../interfaces/val-validator.interface';

@Component({
  selector: 'val-component-base',
  template: '',
})
export class ValComponentBaseComponent implements ValValidator, ValComponent {
  @ContentChild(ValValidationComponent, { static: true }) protected _validator: ValValidationComponent;
  @ViewChild('input', { static: true }) protected _inputEl: ElementRef;
  protected _applied = false;
  protected _v: any;
  protected _css = "form-control";
  protected __isFocused = false;
  protected _isValidated = false;
  protected _isRequired = false;
  protected _isValid = false;

  // to stop loop change
  protected set _isFocused(x: boolean) {
    this.__isFocused = x;
    this._setCss();
  };
  protected get _isFocused() {
    return this.__isFocused;
  };
  public set isValid(x: boolean) {
    this._isValid = x;
    this._setCss();
  }
  public get isValid() {
    return this._isValid;
  }
  public set isValidated(x: boolean) {
    this._isValidated = x;
    this._setCss();
  };
  public get isValidated() {
    return this._isValidated;
  };
  public styleChange = new EventEmitter<void>();
  @Input() set required(x: boolean) {
    this._isRequired = x;
    this._setCss();
  };
  get required() {
    return this._isRequired;
  }
  @HostBinding('class') get cssClass() {
    return this._css;
  }
  @Input() disabled = false;
  @Input() size: 'lg' | 'sm' = null;
  @Input() valueChangeEvent: 'change' | 'blur' | 'none' = 'change';
  @Input() setFocus = false;
  @Input() setFocusOnValidationError = false;
  // @HostListener('click', ['$event'])
  apply(): void { }
  public click(e: any) {
    if (!this._isFocused) {
      this._inputEl.nativeElement.focus();
    }
  }
  @HostListener('mousedown', ['$event'])
  public mousedown(e: any) {
    e.stopPropagation();
  }
  @HostListener('mouseup', ['$event'])
  public mouseup(e: any) {
    e.stopPropagation();
  }
  public validate(): boolean {
    if (!this._validator) { return true; }

    this.isValidated = true;
    this.isValid = this._validator.validate(this._v, this._isFocused);
    if (!this.isValid && this.setFocusOnValidationError) {
      this._inputEl.nativeElement.focus();
    }
    return this.isValid;
  }

  public focus = (e: boolean) => {
    this._isFocused = e;
    if (this._validator) {
      this._validator.hasFocus = e;
    }
  }
  private _setCss = () => {
    setTimeout(() => {
      this._css = (this.__isFocused ?
        this._isValidated ?
          this._isValid ? 'form-control component-focus is-valid' : 'form-control position-relative component-focus is-invalid' :
          'form-control component-focus' + (this._isRequired ? ' is-required' : '') :
        this._isValidated ?
          this._isValid ? 'form-control is-valid' : 'form-control position-relative is-invalid' :
          'form-control' + (this._isRequired ? ' is-required' : '')) + (this.disabled ? ' disabled' : '');
    });
    this.styleChange.emit();
  }
}
